<template>
  <b-modal
    :visible="value"
    title="Agendar Visita"
    size="lg"
    hide-footer
    centered
    @change="modalChangeEvent"
  >
    <ScheduleVisitForm
      :data="formData"
      :date-col-width="4"
      :duration-col-width="3"
      seperate-time-field
      class="mb-5"
      @update="updateForm"
    />

    <div class="mt-4 text-right">
      <BfButton
        variant="secondary"
        class="mr-3"
        @click="modalChangeEvent(false)"
      >
        Cancelar
      </BfButton>
      <BfButton @click="saveFormData" :disabled="disableSubmitButton">
        Agendar
      </BfButton>
    </div>
  </b-modal>
</template>

<script>
import ScheduleVisitForm from '@/components/FormGroups/ScheduleVisitForm';
import { isEqual, moment } from '@/utils';

export default {
  name: 'ScheduleVisitModal',

  props: {
    formData: {
      type: Object,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      internalFormData: this.formData,
    };
  },

  methods: {
    updateInternalFormData(key, value) {
      this.internalFormData = {
        ...this.internalFormData,
        [key]: value,
      };
    },

    updateForm({ key, value }) {
      const dateFormat = 'YYYY-MM-DD HH:mm:ss';

      if (key === 'startTime' || key === 'fecha_hora_ini') {
        const { fecha_hora_ini: formStartDate } = this.internalFormData;
        const parsedStartDate = formStartDate ? moment(formStartDate, dateFormat) : moment();

        if (key === 'startTime') {
          const [hour, minute, second] = value.split(':');

          this.updateInternalFormData(
            'fecha_hora_ini',
            parsedStartDate.set({ hour, minute, second }).format(dateFormat)
          );
        } else if (key === 'fecha_hora_ini') {
          const [date] = value.split(' ');
          const [year, month, day] = date.split('-');

          this.updateInternalFormData(
            'fecha_hora_ini',
            parsedStartDate.set({ year, month: month - 1, date: day }).format(dateFormat)
          );
        }
      } else {
        this.updateInternalFormData(key, value);
      }
    },

    modalChangeEvent(visible) {
      this.$emit('input', visible);

      if (!visible) {
        this.internalFormData = this.formData;
      }
    },

    saveFormData() {
      this.$emit('update', this.internalFormData);
    },
  },

  computed: {
    disableSubmitButton() {
      return this.internalFormData.duration <= 0 || !this.internalFormData.fecha_hora_ini;
    },
  },

  watch: {
    formData(newData) {
      if (!isEqual(newData, this.internalFormData)) {
        this.internalFormData = newData;
      }
    },
  },

  components: {
    ScheduleVisitForm,
  },
};
</script>
